export default __webpack_public_path__ + "static/media/ico-timeline.d1677b1a.svg";